import { useParams } from "react-router-dom";
import EditUserProfileForm from "./EditUserProfileForm";
import { useGetUsersQuery } from "./usersApiSlice";
import PulseLoader from "react-spinners/PulseLoader";
import useTitle from "../../hooks/useTitle";

const EditUserProfile = () => {
  useTitle("Korisnicki profil");

  const { id } = useParams();

  //ovo proverava kesh
  // const { user } = useGetUsersQuery("usersList", {
  //   selectFromResult: ({ data }) => ({
  //     user: data?.entities[id],
  //   }),
  // });

  const { user } = useGetUsersQuery("usersList", {
    selectFromResult: ({ data }) => ({
      user: data?.entities[id],
    }),
    refetchOnMountOrArgChange: true,
  });

  if (!user) return <PulseLoader color={"#FFF"} />;

  const content = <EditUserProfileForm user={user} />;

  return content;
};
export default EditUserProfile;
